/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Keywords_PresentInputs */

const en_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const de_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const fr_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const es_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const it_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const nl_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const pl_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const fi_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const da_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

const sv_deep_match_keywords_present = /** @type {(inputs: Deep_Match_Keywords_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present`)
};

/**
* | output |
* | --- |
* | "Present" |
*
* @param {Deep_Match_Keywords_PresentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_keywords_present = /** @type {((inputs?: Deep_Match_Keywords_PresentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Keywords_PresentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_keywords_present(inputs)
	if (locale === "fr") return fr_deep_match_keywords_present(inputs)
	if (locale === "es") return es_deep_match_keywords_present(inputs)
	if (locale === "it") return it_deep_match_keywords_present(inputs)
	if (locale === "nl") return nl_deep_match_keywords_present(inputs)
	if (locale === "pl") return pl_deep_match_keywords_present(inputs)
	if (locale === "fi") return fi_deep_match_keywords_present(inputs)
	if (locale === "da") return da_deep_match_keywords_present(inputs)
	if (locale === "sv") return sv_deep_match_keywords_present(inputs)
	return en_deep_match_keywords_present(inputs)
});